angular.module('wbComponents').directive 'wbNumberChange', ->
  restrict: 'A'
  scope: true
  link: ($scope, $el, $attrs) ->
    $attrs.wbNumberChange
    $scope.$watch $attrs.wbNumberChange, (value) ->
      $scope.wbNumberValue = Math.abs(+value)
      $el.addClass('number-change')
      if +value > 0
        $el.removeClass('number-change-negative')
        $el.addClass('number-change-positive')
      else if value < 0
        $el.removeClass('number-change-positive')
        $el.addClass('number-change-negative')
      else
        $el.removeClass('number-change-negative')
        $el.removeClass('number-change-positive')
